import Vue from 'vue'
import Vuex from 'vuex'
import amount from './amount'
import checked from './checked'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    amount, //总金额,
    checked,
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js